import {
  mobileAccordions,
  resetSecondaryMenu,
  openMenu,
  closeMenu,
  navScroll,
  switchContent,
  closeSearch,
} from './nav-utils'

import { scrollLock } from './utils'

let headerEl = document.getElementById('nav-wrapper')

headerEl.props = {}
headerEl.props.navMargin = 0
headerEl.props.transformAmount = 0
headerEl.props.lastScroll = window.scrollY
headerEl.props.submenuOpen = false
headerEl.props.activeMenu = 0

document.querySelectorAll('.nav').forEach((nav) => {
  resetSecondaryMenu(nav)
})

document.querySelectorAll('.megamenu-opener').forEach((megamenuOpener) => {
  megamenuOpener.addEventListener('click', (e) => {
    e.preventDefault()
    e.stopPropagation()

    // close search
    closeSearch()

    let megamenuEl = document.querySelector(
      `.nav[data-megamenu="${megamenuOpener.getAttribute('data-megamenu')}"]`
    )

    if (megamenuOpener.classList.contains('active')) {
      closeMenu(megamenuEl)
    } else {
      openMenu(megamenuEl, megamenuOpener)
    }
  })
})

document.querySelectorAll('.nav').forEach((el) => {
  const overlay = el.querySelector('.nav__overlay')

  el.props = {}

  overlay.addEventListener('click', () => {
    closeMenu(el)
  })

  el.querySelectorAll('.nav__main-menu-link').forEach((button) => {
    if (window.matchMedia('(hover: hover)').matches) {
      button.addEventListener('mouseover', () => {
        switchContent(button, el)
      })
    }

    button.addEventListener('click', () => {
      switchContent(button, el)
    })

    button.addEventListener('focus', () => {
      switchContent(button, el)
    })

    button.addEventListener('click', () => {
      el.classList.add('nav--secondary-menu-open')
      switchContent(button, el)
    })
  })

  el.querySelectorAll('.nav__secondary-menu__close').forEach((button) => {
    button.addEventListener('click', () => {
      resetSecondaryMenu(el)
    })
  })

  el.querySelectorAll('.nav__mobile-close').forEach((closeButton) => {
    closeButton.addEventListener('click', () => {
      closeMenu(el)
    })
  })

  // mobile accordion
  mobileAccordions(el, true)
})

// hide / show nav on scroll

window.addEventListener('scroll', () => {
  navScroll(headerEl)
})

navScroll(headerEl)

// mobile navigation

let burger = document.querySelector('.menu-trigger')
let mobileNav = document.querySelector('.nav--mobile')

burger.addEventListener('click', (e) => {
  e.stopImmediatePropagation()

  if (!burger.classList.contains('active')) {
    openMenu(mobileNav, burger)
    scrollLock(true)
  } else {
    closeMenu(mobileNav)
  }
})

// reset stuff when resizing from desktop to mobile

let mobileMedia = window.matchMedia('(max-width: 640px)')

mobileMedia.addEventListener('change', () => {
  // close all navs
  document.querySelectorAll('.nav').forEach((el) => {
    closeMenu(el)
  })

  if (mobileMedia.matches) {
    // should reset desktop related stuff
    headerEl.style.marginTop = 0
    headerEl.props.navMargin = 0
  } else {
    // should reset mobile related stuff
  }
})
